import { DateTime, Duration } from 'luxon';

type checkIfTimeNowInBetweenAsapTimeUsingDzmsType = (
  supportedDeliveryZone: { closeAt: string; openAt: string },
  useDeliveryzonesMs: boolean,
) => boolean;

export const getOpenAndCloseHours = (supportedDeliveryZone, branchDetails, isDelivery) => {
  const today = DateTime.now();
  const dayNameShort = today.weekdayShort.toLocaleLowerCase();
  const { closeAt: deliveryCloseAt, openAt: deliveryOpenAt } =
    supportedDeliveryZone?.openingHours?.find(weekDay => weekDay.day === dayNameShort) || {};
  const { 'close-at': branchCloseAt, 'open-at': branchOpenAt } =
    branchDetails?.openingHours?.find(weekDay => weekDay.day === dayNameShort) || {};
  return isDelivery ? { closeAt: deliveryCloseAt, openAt: deliveryOpenAt } : { closeAt: branchCloseAt, openAt: branchOpenAt };
};

function getEndTime(StoreOpenAndCloseHours) {
  const { closeAt, openAt } = StoreOpenAndCloseHours;
  const close = DateTime.fromFormat(closeAt, 'HH:mm').toLocal();
  const open = DateTime.fromFormat(openAt, 'HH:mm').toLocal();
  if (open >= close) return close.plus(Duration.fromObject({ days: 1 }));
  return close;
}

export const checkIfTimeNowInBetweenAsapTimeUsingDzms: checkIfTimeNowInBetweenAsapTimeUsingDzmsType = (
  StoreOpenAndCloseHours,
  useDeliveryzonesMs,
) => {
  if (!useDeliveryzonesMs) return false;
  const today = DateTime.now();
  const nowTime = today.toLocal();
  const endTime = getEndTime(StoreOpenAndCloseHours);
  const isTimeNowLaterThanEndTime = nowTime < endTime;

  return isTimeNowLaterThanEndTime;
};
